import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

import { Tab } from './tab';
import { TabAbstractComponent, makeTabProviders } from './tab-abstract.component';

const TAB_PREFIX = 'shrd-uic-tab-content-';

@Component({
  selector: 'shrd-uic-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
  providers: makeTabProviders(TabComponent),
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabComponent extends TabAbstractComponent implements OnInit, OnDestroy {
  override tab = new Tab();

  @Output() tabClick = new EventEmitter<void>();
  @Input() private readonly contentId: string;
  @Input() private readonly initialTrigger = true;

  @HostBinding('class.shrd-uic-tab') readonly hostClass = true;

  ngOnInit(): void {
    this.tab.contentReference = this.contentId;
    this.tab.id = this.id;

    this.tabService.register(this.tab);

    this.isDisabled = this.disabled;

    if (this.active) {
      if (this.initialTrigger) {
        this.changeActive();
      } else {
        this.tabService.activeTab = this.tab;
        this.setActive(this.tab);
      }
    }

    this.subscribeToTabChange();
  }

  override setActive(tab: Tab): void {
    this.tab.active = this.active = this.isActive(tab);
    if (this.tab.active) {
      this.controls = this.ariaControls || TAB_PREFIX + tab.contentReference;
    } else {
      this.controls = null;
    }
    this.cdr.detectChanges();
  }

  onClick(): boolean {
    this.changeActive();
    this.tabClick.emit();
    return false;
  }
}
